import React, { useState } from 'react';

const CreateClub = ({ onNext, onPrev, onDataUpdate }) => {
  const [clubType, setClubType] = useState('essential');
  const [clubImage, setClubImage] = useState('');
  const [clubName, setClubName] = useState('');
  const [description, setDescription] = useState('');
  const [clubPrice, setClubPrice] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    onDataUpdate({ clubType, clubImage, clubName,clubPrice });
    onNext();
  };

  return (
    <form onSubmit={handleSubmit}>
      <h3 className="mb-4">Club Details</h3>
      <div className="mb-3">
        <label htmlFor="clubType" className="form-label">Club Type</label>
        <select
          className="form-select"
          id="clubType"
          value={clubType}
          onChange={(e) => setClubType(e.target.value)}
          required disabled
        >
          <option value="essential" selected>Essential - Customers pay a one time fee to join your club.</option>
        </select>
        <small className="form-text text-muted">
          More options coming soon!
        </small>
      </div>
      <div className="mb-3">
        <label htmlFor="clubName" className="form-label">Club Name</label>
        <input
          type="text"
          className="form-control"
          id="clubName"
          value={clubName}
          onChange={(e) => setClubName(e.target.value)}
          // required
        />
      </div>      
      <div className="mb-3">
        <label htmlFor="description" className="form-label">Description</label>
        <textarea
          className="form-control"
          id="description"
          rows="3"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          // required
        />
      </div>
      <div className="mb-3">
        <label htmlFor="clubImage" className="form-label">Image</label>
        <input
          type="file"
          className="form-control"
          id="clubImage"
          value={clubImage}
          onChange={(e) => setClubImage(e.target.value)}
        />
      </div>
      <div className="mb-3">
        <label htmlFor="clubPrice" className="form-label">Membership Cost</label>
        <input
          type="number"
          className="form-control"
          id="clubPrice"
          value={clubPrice}
          onChange={(e) => setClubPrice(e.target.value)}
          min="5"
          // required
        />
        <small className="form-text text-muted">
          Minimum value is $5 USDT/USDD
        </small>
      </div>
      <div className="d-flex justify-content-between">
        <button type="button" className="btn btn-outline-secondary" onClick={onPrev}>Previous</button>
        <button type="submit" className="btn btn-kmint-blue">Next</button>
      </div>
    </form>
  );
};

export default CreateClub;
